<template lang="html">
    <div>
        <header>
            <h2>What's in the bag?</h2>

            <empty-placeholder class="mt30" v-if="bags.length == 0">
                <span v-if="user.type == 'player'"
                    >TIP: Add your clubs here and share with friends and social media followers. Get
                    started by tapping the button below.</span
                >
                <span v-else>
                    TIP: Add your clubs here and share with friends and social media followers.
                </span>
            </empty-placeholder>

            <empty-placeholder class="mt30 warning" v-if="user.type == 'pro'">
                IMPORTANT: This information will appear in your Profile and on your Player accounts,
                please make sure it is accurate.
            </empty-placeholder>

            <ul class="links">
                <li style="transform: translateY(-4px)">
                    <button v-if="!sharing" @click.prevent="share" href="#">
                        <img src="@/assets/share.svg" />
                    </button>
                    <spinner class="spinner" v-else>Loading</spinner>
                </li>
                <li>
                    <a class="cancel" @click.prevent="$router.back()" href="#">
                        <x-icon class="icon" />
                    </a>
                </li>
            </ul>
        </header>

        <draggable
            :forceFallback="true"
            id="playerList"
            handle=".handle"
            v-model="bags"
            @end="finishedDragging"
        >
            <bag-list-item ref="bagList" v-for="club in bags" :key="club.id" :club="club" />
        </draggable>

        <button
            class="button addClub"
            :disabled="form.busy"
            @click.prevent="addClub"
            type="button"
            name="button"
        >
            {{ form.busy ? "Please wait..." : "Add Club" }}
        </button>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";

import draggable from "vuedraggable";
import BagListItem from "@/components/Player/Bag/bag-list-item";
import { XIcon } from "vue-feather-icons";
import { Form } from "vform";
import Spinner from "@/components/Shared/spinner.vue";
export default {
    name: "bag-list",
    components: {
        XIcon,
        BagListItem,
        draggable,
        EmptyPlaceholder,
        Spinner,
    },
    data() {
        return {
            sharing: false,
            oWebViewInterface: window.nsWebViewInterface,
            form: new Form({
                order: "",
            }),
        };
    },
    created() {
        this.oWebViewInterface.on("shareComplete", () => {
            this.sharing = false;
        });
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        bags: {
            get() {
                return this.$store.state.user.bags;
            },
            set($value) {
                // Update the order field with the new order from drag
                var items2 = $value.map(function (item, index) {
                    return {
                        id: item.id,
                        user_id: item.user_id,
                        club: item.club,
                        name: item.name,
                        order: index,
                    };
                });

                this.$store.state.user.bags = items2;
            },
        },
    },
    methods: {
        finishedDragging() {
            console.log("hello world");
            window.axios.post("/bag/order", { clubs: this.bags });
        },
        share() {
            this.sharing = true;
            this.oWebViewInterface.emit("shareImage", {
                url: "https://app.lessonpro.co.uk/share/" + this.$store.state.user.id + "/image",
                text: "Shared from Lesson pro https://lessonpro.co.uk",
            });
        },
        addClub() {
            this.form.order = this.bags.length + 1;
            this.form.post("/bag").then((bag) => {
                this.$store.dispatch("addBagItem", bag.data);

                /*
        this.$nextTick(()=>{
          this.$refs.bagList[this.$refs.bagList.length-1].$refs.bagItem.click();
            this.$refs.bagList[this.$refs.bagList.length-1].$refs.bagItem.focus();
        })
        */
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.addClub {
    margin-top: 20px;
}
.links li a {
    color: white !important;
}
.spinner {
    margin-right: 14px;
    margin-top: -2px;
}
</style>
